<template>
  <div class="menu_shadow">
  </div>
</template>

<script>
export default {
  name: 'shade',
};
</script>
